import {h, Fragment} from "preact"
import { useFacets, useProductFilters } from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"
import {closeSidebar} from "../helpers"

export const toggleButtonId = "toggle-mobile-sidebar"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
            for={toggleButtonId}
        >
            {/* <Icon name="close" /> */}
            <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 5L19 19M19 5L5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
            </svg>
        </label>
    )
}

export default function SideBar() {
    const { loading, facets } = useFacets();
    const { removeAll } = useProductFilters();
    // console.log(facets);
    return facets?.length > 0 ? (
        <>
            <input type="checkbox" id={toggleButtonId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for={toggleButtonId}
            />
            <div
            // ns-col-3 ns-col-l-2
                class="ns-sidebar-wrapper ns-d-none ns-h-100"
                // style={loading ? "opacity: 0.3;" : ""}
            >
                <ToggleSidebarButton />
                {/* ns-h-100 ns-mr-0 ns-mr-md-auto */}
                <div class="ns-sidebar-content ns-relative ns-background-white">
                    <div class="ns-sidebar-header ns-d-flex ns-align-items-baseline">
                        <span class="ns-font-regular ns-color-black">Filter by</span>
                    </div>
                    <div class="ns-sidebar-menu">
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet key={facet.id} facet={facet} />
                                    case "stats":
                                        return <RangeFacet key={facet.id} facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                </div>
                <div class="drawer__row drawer__row--buttons">
                    <button type="button" class="button button--full js-btn-close-drawer no-js-hidden button--filled uppercase menu-is-open" aria-expanded="true" onClick={(e)=>{
                        e.preventDefault();
                        closeSidebar();
                    }}>Apply filters</button>
                    {/* <facet-remove> */}
                        <a class="button button--full facets__clear-button button--outlined uppercase" role="button" onClick={() => {
                        removeAll()
                    }}>Clear all</a>
                    {/* </facet-remove> */}

                </div>
            </div>
        </>
    ) : (
        ""
    )
}
